import { useEffect, useState } from "react";
import { MS_DAY } from "./utils";

/**
 * Relógio do cronômetro. Devolve `null` no primeiro render (SSR) para evitar mismatch
 * de hidratação e, a partir daí, `Date.now()` a cada tick.
 *
 * O passo é adaptativo: 1s quando "Exibir segundos" está ligado ou quando falta menos
 * de um dia (fase em que as caixas viram HRS/MIN/SEG); 60s caso contrário. Assim o
 * último minuto nunca fica parado atualizando de 60 em 60s.
 */
export const useCountdownNow = (
  unpublishAt?: string,
  showSeconds = true,
): number | null => {
  const [now, setNow] = useState<number | null>(null);

  useEffect(() => {
    if (!unpublishAt) return;
    const target = new Date(unpublishAt).getTime();
    if (Number.isNaN(target)) return;

    let timer: ReturnType<typeof setTimeout>;
    const tick = () => {
      setNow(Date.now());
      const inFinalDay = target - Date.now() < MS_DAY;
      timer = setTimeout(tick, showSeconds || inFinalDay ? 1000 : 60_000);
    };
    tick();
    return () => clearTimeout(timer);
  }, [unpublishAt, showSeconds]);

  return now;
};
